import { VehicleMake, VehicleModel } from '../models/vehicle.model';

export const MOCK_VEHICLE_MAKES: VehicleMake[] = [
  { id: 'fiat', nome: 'Fiat' },
  { id: 'volkswagen', nome: 'Volkswagen' },
  { id: 'chevrolet', nome: 'Chevrolet' },
  { id: 'ford', nome: 'Ford' },
  { id: 'honda', nome: 'Honda' },
  { id: 'toyota', nome: 'Toyota' },
  { id: 'hyundai', nome: 'Hyundai' },
  { id: 'renault', nome: 'Renault' },
  { id: 'nissan', nome: 'Nissan' },
  { id: 'peugeot', nome: 'Peugeot' },
];

export const MOCK_VEHICLE_MODELS: VehicleModel[] = [
  // Fiat
  { id: 'uno', nome: 'Uno', makeId: 'fiat', anoInicio: 2010, anoFim: 2025 },
  { id: 'palio', nome: 'Palio', makeId: 'fiat', anoInicio: 2005, anoFim: 2017 },
  { id: 'strada', nome: 'Strada', makeId: 'fiat', anoInicio: 2010, anoFim: 2025 },
  { id: 'toro', nome: 'Toro', makeId: 'fiat', anoInicio: 2016, anoFim: 2025 },
  { id: 'argo', nome: 'Argo', makeId: 'fiat', anoInicio: 2017, anoFim: 2025 },
  { id: 'mobi', nome: 'Mobi', makeId: 'fiat', anoInicio: 2016, anoFim: 2025 },
  
  // Volkswagen
  { id: 'gol', nome: 'Gol', makeId: 'volkswagen', anoInicio: 2008, anoFim: 2025 },
  { id: 'voyage', nome: 'Voyage', makeId: 'volkswagen', anoInicio: 2008, anoFim: 2025 },
  { id: 'fox', nome: 'Fox', makeId: 'volkswagen', anoInicio: 2003, anoFim: 2021 },
  { id: 'polo', nome: 'Polo', makeId: 'volkswagen', anoInicio: 2002, anoFim: 2025 },
  { id: 't-cross', nome: 'T-Cross', makeId: 'volkswagen', anoInicio: 2019, anoFim: 2025 },
  { id: 'saveiro', nome: 'Saveiro', makeId: 'volkswagen', anoInicio: 2009, anoFim: 2025 },
  
  // Chevrolet
  { id: 'onix', nome: 'Onix', makeId: 'chevrolet', anoInicio: 2012, anoFim: 2025 },
  { id: 'prisma', nome: 'Prisma', makeId: 'chevrolet', anoInicio: 2013, anoFim: 2025 },
  { id: 'corsa', nome: 'Corsa', makeId: 'chevrolet', anoInicio: 2002, anoFim: 2012 },
  { id: 'cruze', nome: 'Cruze', makeId: 'chevrolet', anoInicio: 2011, anoFim: 2025 },
  { id: 's10', nome: 'S10', makeId: 'chevrolet', anoInicio: 2011, anoFim: 2025 },
  { id: 'tracker', nome: 'Tracker', makeId: 'chevrolet', anoInicio: 2020, anoFim: 2025 },
  
  // Ford
  { id: 'ka', nome: 'Ka', makeId: 'ford', anoInicio: 2008, anoFim: 2025 },
  { id: 'fiesta', nome: 'Fiesta', makeId: 'ford', anoInicio: 2002, anoFim: 2019 },
  { id: 'focus', nome: 'Focus', makeId: 'ford', anoInicio: 2009, anoFim: 2019 },
  { id: 'ecosport', nome: 'EcoSport', makeId: 'ford', anoInicio: 2003, anoFim: 2025 },
  { id: 'ranger', nome: 'Ranger', makeId: 'ford', anoInicio: 2012, anoFim: 2025 },
  
  // Honda
  { id: 'civic', nome: 'Civic', makeId: 'honda', anoInicio: 2006, anoFim: 2025 },
  { id: 'fit', nome: 'Fit', makeId: 'honda', anoInicio: 2003, anoFim: 2025 },
  { id: 'city', nome: 'City', makeId: 'honda', anoInicio: 2009, anoFim: 2025 },
  { id: 'hr-v', nome: 'HR-V', makeId: 'honda', anoInicio: 2015, anoFim: 2025 },
  
  // Toyota
  { id: 'corolla', nome: 'Corolla', makeId: 'toyota', anoInicio: 2008, anoFim: 2025 },
  { id: 'hilux', nome: 'Hilux', makeId: 'toyota', anoInicio: 2005, anoFim: 2025 },
  { id: 'etios', nome: 'Etios', makeId: 'toyota', anoInicio: 2012, anoFim: 2021 },
  { id: 'yaris', nome: 'Yaris', makeId: 'toyota', anoInicio: 2018, anoFim: 2025 },
  
  // Hyundai
  { id: 'hb20', nome: 'HB20', makeId: 'hyundai', anoInicio: 2012, anoFim: 2025 },
  { id: 'creta', nome: 'Creta', makeId: 'hyundai', anoInicio: 2016, anoFim: 2025 },
  { id: 'tucson', nome: 'Tucson', makeId: 'hyundai', anoInicio: 2016, anoFim: 2025 },
  
  // Renault
  { id: 'sandero', nome: 'Sandero', makeId: 'renault', anoInicio: 2007, anoFim: 2025 },
  { id: 'logan', nome: 'Logan', makeId: 'renault', anoInicio: 2007, anoFim: 2025 },
  { id: 'duster', nome: 'Duster', makeId: 'renault', anoInicio: 2011, anoFim: 2025 },
  { id: 'kwid', nome: 'Kwid', makeId: 'renault', anoInicio: 2017, anoFim: 2025 },
  
  // Nissan
  { id: 'march', nome: 'March', makeId: 'nissan', anoInicio: 2011, anoFim: 2025 },
  { id: 'versa', nome: 'Versa', makeId: 'nissan', anoInicio: 2011, anoFim: 2025 },
  { id: 'kicks', nome: 'Kicks', makeId: 'nissan', anoInicio: 2016, anoFim: 2025 },
  
  // Peugeot
  { id: '208', nome: '208', makeId: 'peugeot', anoInicio: 2012, anoFim: 2025 },
  { id: '2008', nome: '2008', makeId: 'peugeot', anoInicio: 2015, anoFim: 2025 },
];

export function getYears(): number[] {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];
  for (let year = currentYear; year >= 2005; year--) {
    years.push(year);
  }
  return years;
}

